import { StrictMode } from "react";
import { render } from "react-dom";
import App from "./App";
import { Provider } from "react-redux";
import "./index.css";
import { store } from './features/store';

render(
     <StrictMode>
          <Provider store={store}>
               <App />
          </Provider>
     </StrictMode>,
     document.getElementById("root")
);
